import {
  BeneficiaryType,
  UpdateBeneficiaryType
} from 'apps/user/types/on-boarding.type';
import { AxiosError, AxiosInstance } from 'axios';
import { Beneficiaries, BeneficiaryDto } from 'service/dto/beneficiary.dto';
import { errorHandler } from 'utils';

class BeneficiaryService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createBeneficiary = async (beneficiaryType: BeneficiaryType) => {
    try {
      const response = await this.baseService.post(
        '/beneficiary/create',
        beneficiaryType
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  updateBeneficiary = async (
    beneficiaryId: number,
    update: UpdateBeneficiaryType
  ) => {
    try {
      const response = await this.baseService.put(
        `/beneficiary/${beneficiaryId}`,
        update
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getBeneficiaries = async (
    search?: string | undefined
  ): Promise<Beneficiaries> => {
    try {
      const response = await this.baseService.get(
        `/beneficiary?search=${search}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deleteBeneficiary = async (beneficiaryId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/beneficiary/${beneficiaryId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getBeneficiary = async (beneficiaryId: number): Promise<BeneficiaryDto> => {
    try {
      const response = await this.baseService.get(
        `/beneficiary/${beneficiaryId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getBeneficiaryDetails = async (
    beneficiaryId: number
  ): Promise<BeneficiaryDto> => {
    try {
      const response = await this.baseService.get(
        `/beneficiary/details/${beneficiaryId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  checkIfEmailInUse = async (email: string) => {
    const response = await this.baseService.get(
      `/beneficiary/email-exists/${email}`
    );
    return response.data;
  };
}
export default BeneficiaryService;
